module.exports = __webpack_public_path__ + "static/day-2-rainforest-plants-d8392bbb167ff5ed409c25420247b7e3.jpg";